import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Progress } from './react-sweet-progress'

import styles from './progressbar.css'

class ProgressBar extends Component {
  constructor (props) {
    super(props)

    this.state = {
      percent: props.percent
    }

    this.updateTimeout = null

    this.countTo = this.countTo.bind(this)
  }

  componentWillReceiveProps (nextProps) {
    const { percent } = this.props

    if (nextProps.percent !== percent) {
      clearTimeout(this.updateTimeout)
      this.countTo(nextProps.percent)
    }
  }

  componentWillUnmount () {
    clearTimeout(this.updateTimeout)
  }

  renderAsLine () {
    const { className } = this.props
    const { percent } = this.state
    const displayPercent = Math.ceil(percent)
    const prefix = `${displayPercent}`.length > 1 ? '' : '0'
    return (
      <div className={classnames(className, styles.lineWrapper)}>
        <p className={styles.percent}>{`${prefix}${displayPercent}%`}</p>
        <div className={styles.lineTrack}>
          <div
            className={styles.progress}
            style={{ transform: `scaleX(${displayPercent / 100})` }}
          />
        </div>
      </div>
    )
  }

  render () {
    const { shape, className, ...props } = this.props
    const { percent } = this.state
    const displayPercent = Math.ceil(percent)

    if (shape === 'line') {
      return this.renderAsLine()
    }

    return (
      <div className={className}>
        <Progress
          {...props}
          percent={displayPercent}
          type={shape}
          theme={{
            success: {
              symbol: `${displayPercent}%`
            }
          }}
        />
      </div>
    )
  }

  countTo (target) {
    let targetPercentage = (this.state.percent + 1)
    if (this.state.percent > target) {
      targetPercentage = this.state.percent - 1
    }
    this.setState({ percent: targetPercentage })

    if (targetPercentage !== target) {
      const delay = Math.abs(target - this.state.percent) * 20
      this.updateTimeout = setTimeout(this.countTo, delay, target)
    }
  }
}

ProgressBar.defaultProps = {
  strokeWidth: 6,
  trailWidth: 6,
  strokeColor: '#fff',
  trailColor: '#4E5252',
  percent: 0,
  strokeLinecap: 'butt',
  className: null
}

ProgressBar.propTypes = {
  shape: PropTypes.oneOf(['line', 'circle']).isRequired,
  strokeLinecap: PropTypes.oneOf(['butt', 'square', 'round']),
  strokeWidth: PropTypes.number,
  trailWidth: PropTypes.number,
  strokeColor: PropTypes.string,
  trailColor: PropTypes.string,
  percent: PropTypes.number,
  className: PropTypes.string

}

export default ProgressBar
